import styled, { keyframes } from 'styled-components';

const mainAnimation = keyframes`
  100% { transform: rotate(360deg);
`;

const dotAnimation = keyframes`
  80%, 100% { transform: rotate(360deg);
`;

const dotAnimationBefore = keyframes`
  50% {
    transform: scale(0.4); 
  }; 
  100%, 0% {
    transform: scale(1.0); 
  } 
`;

export const Container = styled.div`
  width: 24px;
  height: 24px;
  position: relative;
  animation: ${mainAnimation} 2.5s infinite linear both;
  margin-right: 16px;
`;

interface IDotProps {
  isContrast?: boolean;
}

export const Dot = styled.div<IDotProps>`
  width: 100%;
  height: 100%;
  position: absolute;
  left: 0;
  top: 0;
  animation: ${dotAnimation} 2s infinite ease-in-out both;

  &:before {
    content: '';
    display: block;
    width: 20%;
    height: 20%;
    background-color: ${({ theme: { colors }, isContrast }) =>
      isContrast ? colors.button.contrast : colors.button.primary};
    border-radius: 100%;
    animation: ${dotAnimationBefore} 2s infinite ease-in-out both;

    &:nth-child(4):before {
      animation-delay: -0.8s;
    }
    &:nth-child(5):before {
      animation-delay: -0.7s;
    }
    &:nth-child(6):before {
      animation-delay: -0.6s;
    }
  }

  &:nth-child(1) {
    animation-delay: -1.1s;
    &:before {
      animation-delay: -1.1s;
    }
  }
  &:nth-child(2) {
    animation-delay: -1s;
    &:before {
      animation-delay: -1s;
    }
  }
  &:nth-child(3) {
    animation-delay: -0.9s;
    &:before {
      animation-delay: -0.9s;
    }
  }
  &:nth-child(4) {
    animation-delay: -0.8s;
    &:before {
      animation-delay: -0.8s;
    }
  }
  &:nth-child(5) {
    animation-delay: -0.7s;
    &:before {
      animation-delay: -0.7s;
    }
  }
  &:nth-child(6) {
    animation-delay: -0.6s;
    &:before {
      animation-delay: -0.6s;
    }
  }
`;
